// extracted by mini-css-extract-plugin
export var container = "styles-module--container--3e9ac";
export var membership_credit = "styles-module--membership_credit--cdc62";
export var membership_credit_content = "styles-module--membership_credit_content--50efb";
export var membership_credit_frame = "styles-module--membership_credit_frame--81a94";
export var membership_credit_frame_close = "styles-module--membership_credit_frame_close--41f63";
export var membership_credit_frame_login = "styles-module--membership_credit_frame_login--dbdfe";
export var membership_credit_scroll = "styles-module--membership_credit_scroll--87a00";